import React, { useEffect, useState, useRef } from "react";
import Slider from "react-slick";

const Home = () => {
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  const slider1 = useRef(null);
  const slider2 = useRef(null);
  const videoRef = useRef(null);
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  const [isMuted, setIsMuted] = useState(true);
  const onVideoPlay = () => {
    setIsVideoPlaying(true);

    if (videoRef.current) {
      videoRef.current.muted = true;
      setIsMuted(false);
    }
  };
  const onVideoPause = () => {
    setIsVideoPlaying(false);
  };


  useEffect(() => {
    setNav1(slider1.current);
    setNav2(slider2.current);
  }, []);

  const [sliderStyle, setSliderStyle] = useState({});


  useEffect(() => {
    let heroEl = document.querySelector('.hero-section');
    if (heroEl) {
      setTimeout(() => {
        heroEl.classList.add('is-animating');
        setTimeout(() => {
          setSliderStyle({
            animation: 'none',
            opacity: '1',
            transform: 'translate(0, 0)'
          });
        }, 1500);
      }, 3500); // Changed from 100ms to 3500ms to wait for Loader
    }
  }, []);

  const [formData, setFormData] = useState({
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  city: "",
  state: "",
  country: "",
  location: "",
  certificate: null,
  lease: null,
});

const [errors, setErrors] = useState({});

// ✅ TEXT INPUT HANDLER
const handleChange = (e) => {
  const { name, value } = e.target;

  setFormData((prev) => ({
    ...prev,
    [name]: value,
  }));

  setErrors((prev) => ({
    ...prev,
    [name]: "",
  }));
};

// ✅ FILE INPUT HANDLER (FIXED)
const handleFileChange = (e) => {
  const { name, files } = e.target;

  if (!files.length) return;

  const file = files[0];

  setFormData((prev) => ({
    ...prev,
    [name]: file,
  }));

  // ✅ REMOVE ERROR immediately after file select
  setErrors((prev) => ({
    ...prev,
    [name]: "",
  }));
};

// ✅ VALIDATION
const validateForm = () => {
  let newErrors = {};

  // required fields
  Object.keys(formData).forEach((key) => {
    if (!formData[key]) {
      newErrors[key] = "This field is required";
    }
  });

  // phone validation
  if (formData.phone) {
    const phoneRegex = /^[0-9]{10,15}$/;

    if (!phoneRegex.test(formData.phone)) {
      newErrors.phone = "Enter a valid phone number (10–15 digits)";
    }
  }

  setErrors(newErrors);

  return Object.keys(newErrors).length === 0;
};

// ✅ SUBMIT
const handleSubmit = (e) => {
  e.preventDefault();

  if (validateForm()) {
    alert("Form submitted successfully!");
    console.log(formData);
  }
};
  useEffect(() => {
    // Wave text stagger
    const waveContainers = document.querySelectorAll('.wave-text-container');
    waveContainers.forEach(container => {
      const spans = container.querySelectorAll('.hero-word-wrap > span');
      spans.forEach((span, index) => {
        span.style.animationDelay = `${index * 0.035}s`;
      });
    });

    // Signup Section observer
    let signupObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
        }
      });
    }, { threshold: 0.3 });

    let signupEl = document.querySelector('.signup-section');
    if (signupEl) {
      signupObserver.observe(signupEl);
    }

    // Refresh AOS
    if (window.AOS) {
      setTimeout(() => {
        window.AOS.refresh();
      }, 500);
    }

    return () => {
      if (signupEl) signupObserver.unobserve(signupEl);
    }
  }, []);

  // Simple stats counter animation
  useEffect(() => {
    const duration = 3000;
    const target = 1250;
    let start = 0;
    let startTime = null;

    const el = document.getElementById("stats-counter");
    if (!el) return;

    function updateCounter(currentTime) {
      if (!startTime) startTime = currentTime;
      const progress = Math.min((currentTime - startTime) / duration, 1);
      const value = Math.floor(progress * target);
      el.innerHTML = value + ' <i class="fa-solid fa-plus"></i>';
      if (progress < 1) requestAnimationFrame(updateCounter);
    }
    requestAnimationFrame(updateCounter);
  }, []);

  const toggleVideo = async () => {
    if (!videoRef.current) return;

    try {
      if (videoRef.current.paused) {
        await videoRef.current.play();

        // ✅ ALWAYS UNMUTE ON PLAY
        videoRef.current.muted = false;
        setIsMuted(false);

        setIsVideoPlaying(true);
      } else {
        videoRef.current.pause();
        setIsVideoPlaying(false);
      }
    } catch (err) {
      console.log("Video error:", err);
    }
  };

  const toggleMute = () => {
    if (!videoRef.current) return;

    const newMuted = !videoRef.current.muted;

    videoRef.current.muted = newMuted;
    setIsMuted(newMuted);
  };
  const heroSliderSettings = {
    dots: false,
    infinite: true,
    speed: 800,
    fade: true,
    cssEase: 'linear',
    slidesToShow: 1,
    adaptiveHeight: false,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    pauseOnHover: false
  };

  return (
    <>
      {/* Hero Section */}
      <section className="hero-section" id="home">
        <div className="container-fluid hero-container">
          <div className="row align-items-center">
            {/* Static Text Column */}
            <div className="col-lg-7 hero-text-col">
              <h1 className="hero-title" data-aos="zoom-in-right" data-aos-duration="1200">
                <span className="d-none d-md-block wave-text-container">
                  <div className="hero-word-wrap"><span>R</span></div>
                  <div className="hero-word-wrap"><span>u</span></div>
                  <div className="hero-word-wrap"><span>n</span></div>
                  &nbsp;
                  <div className="hero-word-wrap"><span>M</span></div>
                  <div className="hero-word-wrap"><span>a</span></div>
                  <div className="hero-word-wrap"><span>t</span></div>
                  <div className="hero-word-wrap"><span>c</span></div>
                  <div className="hero-word-wrap"><span>h</span></div>
                  <div className="hero-word-wrap"><span>e</span></div>
                  <div className="hero-word-wrap"><span>s</span></div>
                  &nbsp;
                  <div className="hero-word-wrap"><span>W</span></div>
                  <div className="hero-word-wrap"><span>i</span></div>
                  <div className="hero-word-wrap"><span>t</span></div>
                  <div className="hero-word-wrap"><span>h</span></div>
                  <div className="hero-word-wrap"><span>o</span></div>
                  <div className="hero-word-wrap"><span>u</span></div>
                  <div className="hero-word-wrap"><span>t</span></div>
                  <br />
                  <div className="hero-word-wrap"><span>R</span></div>
                  <div className="hero-word-wrap"><span>e</span></div>
                  <div className="hero-word-wrap"><span>f</span></div>
                  <div className="hero-word-wrap"><span>e</span></div>
                  <div className="hero-word-wrap"><span>r</span></div>
                  <div className="hero-word-wrap"><span>e</span></div>
                  <div className="hero-word-wrap"><span>e</span></div>
                  &nbsp;
                  <span className="text-primary-green" style={{ background: 'none', WebkitBackgroundClip: 'border-box', WebkitTextFillColor: 'initial' }}>
                    <div className="hero-word-wrap"><span style={{ background: 'linear-gradient(180deg, #00C983 0%, #FFFFFF 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>P</span></div>
                    <div className="hero-word-wrap"><span style={{ background: 'linear-gradient(180deg, #00C983 0%, #FFFFFF 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>r</span></div>
                    <div className="hero-word-wrap"><span style={{ background: 'linear-gradient(180deg, #00C983 0%, #FFFFFF 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>o</span></div>
                    <div className="hero-word-wrap"><span style={{ background: 'linear-gradient(180deg, #00C983 0%, #FFFFFF 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>b</span></div>
                    <div className="hero-word-wrap"><span style={{ background: 'linear-gradient(180deg, #00C983 0%, #FFFFFF 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>l</span></div>
                    <div className="hero-word-wrap"><span style={{ background: 'linear-gradient(180deg, #00C983 0%, #FFFFFF 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>e</span></div>
                    <div className="hero-word-wrap"><span style={{ background: 'linear-gradient(180deg, #00C983 0%, #FFFFFF 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>m</span></div>
                    <div className="hero-word-wrap"><span style={{ background: 'linear-gradient(180deg, #00C983 0%, #FFFFFF 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>s</span></div>
                    <img src="/images/banner-text.png" alt="" />
                  </span>
                </span>
                <span className="d-block d-md-none wave-text-container">
                  Run Matches
                  Without <span className="text-primary-green">Referee</span>
                  <span className="text-primary-green">Problems</span>
                </span>
              </h1>
              <p className="hero-subtitle">
                Stop canceling matches due to official shortages. Remote Ref brings certified, unbiased officiating to your field via high-definition live streaming. Real calls. Real-time. Remote.
              </p>
              <p className="hero-subtitle hero-subtitle-mbl">
                Stop canceling matches due to official shortages. Remote Ref brings certified.
              </p>

              <div className="store-links">
                <a href="#"><img src="/images/app-img1.png" alt="App Store" /></a>
                <a href="#"><img src="/images/app-img2.png" alt="Google Play" /></a>
              </div>

             <div
                className="video-popup custom-video-btn"
                onClick={() => {
                  const section = document.getElementById("video");
                  section?.scrollIntoView({ behavior: "smooth" });
                }}
              >
                <img src="/images/watch-video.png" alt="" />
              </div>

              <div className="ref-stats" data-aos="fade-up" data-aos-duration="1200">
                <div className="stats-text">
                  <span className="stats-label"><img src="/images/check.png" alt="" /> Referees Registered</span>
                  <h2 className="stats-number" id="stats-counter">0 <i className="fa-solid fa-plus"></i></h2>
                </div>
                <div className="avatar-group">
                  <img src="/images/refree-img1.png" alt="user" className="avatar" />
                  <img src="/images/refree-img2.png" alt="user" className="avatar" />
                  <img src="/images/refree-img3.png" alt="user" className="avatar" />
                  <img src="/images/refree-img4.png" alt="user" className="avatar" />
                </div>
              </div>
            </div>

            {/* Image Slider Column */}
            <div className="col-lg-5 hero-video-col position-relative">
              <div style={sliderStyle} className="hero-image-slider">
                <Slider {...heroSliderSettings}>
                  <div className="slider-item">
                    <div className="hero-video-wrapper banner-img1">
                      <img src="/images/banner-img1.png" alt="" />
                    </div>
                  </div>
                  <div className="slider-item">
                    <div className="hero-video-wrapper">
                      <img src="/images/banner-img2.png" alt="Alternate slide layout" />
                    </div>
                  </div>
                  <div className="slider-item">
                    <div className="hero-video-wrapper">
                      <img src="/images/illustration.png" alt="Alternate slide layout" />
                      <video loop autoPlay muted src="/images/onboarding.mp4"></video>
                    </div>
                  </div>
                </Slider>
              </div>
            </div>
          </div>
        </div>
        <div className="hero-glow"></div>
      </section>

      {/* Features Section */}
      <section className="features-section" id="features">
        <div className="container-fluid">
          <div className="row features-header">
            <div className="col-lg-6" data-aos="zoom-in-right" data-aos-duration="1200">
              <span className="section-label"><span></span> Why Choose Us?</span>
              <h2 className="section-title">Key <span className="text-primary-green">Features</span></h2>
            </div>
            <div className="col-lg-5 ms-auto" data-aos="zoom-in-left" data-aos-duration="1200">
              <p>Our platform ensures club, referee, and sports complex integration to build high levels of intelligent matchmaking to make sure you succeed in operations.</p>
            </div>
          </div>

          <div className="row g-4" data-aos="fade-up" data-aos-duration="1200">
            <div className="col-6 col-md-6 col-lg-3">
              <div className="feature-card">
                <div className="feature-icon"><img src="/images/feature-icon1.png" alt="" /></div>
                <div className="feature-text-wrapper">
                  <div className="feature-content-front">
                    <h5 className="feature-card-title">Remote officiating</h5>
                    <p className="feature-card-desc">Limit physical toll</p>
                  </div>
                  <div className="feature-content-back">
                    <p>Referees officiate live matches from a safe remote environment via HD stream, full authority, zero physical risk.</p>
                  </div>
                  <div className="feature-content-back feature-content-back-mbl">
                    <p>Referees officiate live matches from remote environment via HD stream full authority, zero physical risk.</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-6 col-md-6 col-lg-3">
              <div className="feature-card">
                <div className="feature-icon"><img src="/images/feature-icon2.png" alt="" /></div>
                <div className="feature-text-wrapper">
                  <div className="feature-content-front">
                    <h5 className="feature-card-title">Intelligent matchmaking</h5>
                    <p className="feature-card-desc">Engine platform</p>
                  </div>
                  <div className="feature-content-back">
                    <p>Instead of manually searching or assigning officials, the system analyzes multiple factors like referee experience, certification level, availability, location, and past performance to find the best possible match for each game.</p>
                  </div>
                  <div className="feature-content-back feature-content-back-mbl">
                    <p>Instead of manually searching or assigning officials, system
                      analyzes multiple factors to find best possible match for each game</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-6 col-md-6 col-lg-3">
              <div className="feature-card">
                <div className="feature-icon"><img src="/images/feature-icon3.png" alt="" /></div>
                <div className="feature-text-wrapper">
                  <div className="feature-content-front">
                    <h5 className="feature-card-title">Child referee monitoring</h5>
                    <p className="feature-card-desc">Built-in</p>
                  </div>
                  <div className="feature-content-back">
                    <p>Parents can actively monitor their child’s activities on the platform, including upcoming match assignments, participation, and overall progress. The system also sends timely reminders ensuring they never miss a scheduled game.</p>
                  </div>
                  <div className="feature-content-back feature-content-back-mbl">
                    <p>Parents can actively monitor their child’s activities, upcoming match assignments on the platform. They never miss a scheduled game.</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-6 col-md-6 col-lg-3">
              <div className="feature-card">
                <div className="feature-icon"><img src="/images/feature-icon4.png" alt="" /></div>
                <div className="feature-text-wrapper">
                  <div className="feature-content-front">
                    <h5 className="feature-card-title">All referees undergo</h5>
                    <p className="feature-card-desc">Extensive verification</p>
                  </div>
                  <div className="feature-content-back">
                    <p>The system builds a reliable pool of referees by evaluating key factors such as experience level, certifications, and availability. This ensures that only qualified and committed officials are assigned to matches.</p>
                  </div>
                  <div className="feature-content-back feature-content-back-mbl">
                    <p>The system builds a reliable pool of referees which ensures that only qualified and committed officials are assigned to matches.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="benefits-section" id="how-it-works">
        <div className="container-fluid container-padding">
          <div className="row benefits-row">
            <div className="col-lg-4 benefits-left">
              <div className="benefit-highlight-card">
                <div className="logo-box" data-aos="fade-up" data-aos-duration="1000">
                  <img src="/images/logo1.png" alt="" />
                  <img src="/images/logo-round.png" alt="" className="logo-round" />
                </div>
                <h2 className="benefit-title" data-aos="fade-up" data-aos-duration="1000">
                  Too Many Match Delays?<br />
                  <span className="text-primary-green">One</span> <span>Simple Platform</span>
                </h2>
              </div>
            </div>
            <div className="col-lg-8 benefits-right">
              <div className="row row-cols-1 row-cols-md-2 g-4 benefits-list" data-aos="zoom-in-up" data-aos-duration="1200">
                <div className="col-lg-6 mbl-list">
                  <div className="benefit-item benefit-item-mbl">
                    <div className="icon-box"><img src="/images/benefits-icon1.png" alt="" /></div>
                    <p>Find referees instantly online</p>
                  </div>
                  <div className="benefit-item">
                    <div className="icon-box"><img src="/images/benefits-icon3.png" alt="" /></div>
                    <p>Keep matches running on time</p>
                  </div>
                  <div className="benefit-item">
                    <div className="icon-box"><img src="/images/benefits-icon5.png" alt="" /></div>
                    <p>Schedule games in just a few clicks</p>
                  </div>
                  <div className="benefit-item">
                    <div className="icon-box"><img src="/images/benefits-icon7.png" alt="" /></div>
                    <p>Remote removes on-field pressure</p>
                  </div>
                  <div className="benefit-item">
                    <div className="icon-box"><img src="/images/benefits-icon9.png" alt="" /></div>
                    <p>Simple rating system after every match</p>
                  </div>
                  <div className="benefit-item">
                    <div className="icon-box"><img src="/images/benefits-icon11.png" alt="" /></div>
                    <p>Built-in live communication</p>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="benefit-item">
                    <div className="icon-box"><img src="/images/benefits-icon2.png" alt="" /></div>
                    <p>Fully digital match management</p>
                  </div>
                  <div className="benefit-item">
                    <div className="icon-box"><img src="/images/benefits-icon4.png" alt="" /></div>
                    <p>Easy updates for last-minute changes</p>
                  </div>
                  <div className="benefit-item">
                    <div className="icon-box"><img src="/images/benefits-icon6.png" alt="" /></div>
                    <p>One platform for everything</p>
                  </div>
                  <div className="benefit-item">
                    <div className="icon-box"><img src="/images/benefits-icon8.png" alt="" /></div>
                    <p>Save time and reduce hassle</p>
                  </div>
                  <div className="benefit-item">
                    <div className="icon-box"><img src="/images/benefits-icon10.png" alt="" /></div>
                    <p>Manage matches in a few clicks</p>
                  </div>
                  <div className="benefit-item">
                    <div className="icon-box"><img src="/images/benefits-icon12.png" alt="" /></div>
                    <p>Rate performance after the match</p>
                  </div>
                </div>
                {/* <div className="col-lg-12">
                  <div className="benifits-mbl-btn">
                    <a href="#">See more</a>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Video Placeholder Section */}
      <section className="video-section" id="video">
        <div className="video-bg-split"></div>

        <div className="container-fluid">
          <div className="video-box position-relative">
            <div
              className="video-play-center"
              onClick={toggleVideo}
              style={{ cursor: "pointer" }}
            >
              <i
                className={`fa-solid ${isVideoPlaying ? "fa-pause" : "fa-play"
                  }`}
              ></i>
            </div>

            {/* 🔊 MUTE / UNMUTE BUTTON */}
            <div className={`video-mute-btn ${!isVideoPlaying ? "disabled" : ""}`} onClick={toggleMute}>
              <i
                className={`fa-solid ${isMuted ? "fa-volume-xmark" : "fa-volume-high"
                  }`}
              ></i>
            </div>

            {/* VIDEO */}
            <video
              className="video-player"
              ref={videoRef}
              muted={isMuted}
              playsInline
              onPlay={onVideoPlay}
              onPause={onVideoPause}
              onClick={toggleVideo}
            >
              <source src="/images/video.mp4" type="video/mp4" />
            </video>

            {/* BEFORE PLAY IMAGE */}
            {!isVideoPlaying && (
              <img
                src="/images/solar_football-bold.png"
                alt=""
                className="solar_football-bold"
              />
            )}

            {/* BEFORE PLAY CONTENT */}
            {!isVideoPlaying && (
              <div className="video-content">
                <div className="video-text-group">
                  <h3>See How It Works</h3>
                  <p>
                    Watch this short video to learn how to integrate and manage your daily matches with intelligent referee management anywhere.
                  </p>
                </div>

                <div className="video-store-links">
                  <a href="#">
                    <img src="/images/app-img1.png" alt="App Store" />
                  </a>
                  <a href="#">
                    <img src="/images/app-img2.png" alt="Google Play" />
                  </a>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonial-section" id="reviews">
        <div className="container-fluid">
          <p className="section-label" data-aos="fade-up-right" data-aos-duration="1200"><span></span> What They Says About Us</p>

          <div className="testimonial-slider-wrap" data-aos="fade-up-right" data-aos-duration="1200">
            <img src="/images/qoute.png" alt="" className="qoute" />

            <Slider
              asNavFor={nav2}
              ref={slider1}
              slidesToShow={1}
              slidesToScroll={1}
              arrows={false}
              fade={true}
              speed={800}
              cssEase="cubic-bezier(0.25, 1, 0.5, 1)"
              autoplay={true}
              autoplaySpeed={5000}
              pauseOnHover={false}
              className="testi-quote-slider"
            >
              <div>
                <div className="testi-anim-wrapper">
                  <div className="quote-wrapper" style={{ marginBottom: 0 }}>
                    <h2 className="quote-text">"The communication tools are incredible. Clear audio, no sideline drama. Our games run smoother than ever before."</h2>
                    <div className="quote-icon"><i className="fa-solid fa-quote-right"></i></div>
                  </div>
                </div>
              </div>
              <div>
                <div className="testi-anim-wrapper">
                  <div className="quote-wrapper" style={{ marginBottom: 0 }}>
                    <h2 className="quote-text">"This platform has transformed how we interact with our players. The instant feedback has been a game-changer for our training."</h2>
                    <div className="quote-icon"><i className="fa-solid fa-quote-right"></i></div>
                  </div>
                </div>
              </div>
              <div>
                <div className="testi-anim-wrapper">
                  <div className="quote-wrapper" style={{ marginBottom: 0 }}>
                    <h2 className="quote-text">"I love the simplicity and efficiency of the tools. It allows us to focus on what truly matters, the game and our athletes."</h2>
                    <div className="quote-icon"><i className="fa-solid fa-quote-right"></i></div>
                  </div>
                </div>
              </div>
            </Slider>

            <Slider
              asNavFor={nav1}
              ref={slider2}
              slidesToShow={1}
              slidesToScroll={1}
              dots={false}
              arrows={false}
              fade={true}
              speed={300}
              focusOnSelect={true}
              pauseOnHover={false}
              className="testi-author-slider"
            >
              <div>
                <div className="testi-img">
                  <img src="/images/testi-img.jpg" alt="" />
                  <div className="testi-img-text">
                    <h6>Vanessa R.</h6>
                    <p>Youth Coach</p>
                  </div>
                </div>
              </div>
              <div>
                <div className="testi-img">
                  <img src="/images/testi-img2.jpg" alt="" />
                  <div className="testi-img-text">
                    <h6>Jordan T.</h6>
                    <p>Referee</p>
                  </div>
                </div>
              </div>
              <div>
                <div className="testi-img">
                  <img src="/images/testi-img3.jpg" alt="" />
                  <div className="testi-img-text">
                    <h6>Maria L.</h6>
                    <p>Referee</p>
                  </div>
                </div>
              </div>
            </Slider>

            <div className="testi-btn">
              <span className="testi-prev" onClick={() => slider2.current.slickPrev()}><i className="fa-solid fa-angle-left"></i></span>
              <span className="testi-next" onClick={() => slider2.current.slickNext()}><i className="fa-solid fa-angle-right"></i></span>
            </div>
          </div>
        </div>
      </section>

      {/* Sign Up Form Section */}
      <section className="signup-section">
        <div className="signup-bg-image"></div>
        <div className="signup-overlay"></div>

        <div className="container-fluid signup-container">
          <div className="row signup-header">
            <div className="col-md-8" data-aos="zoom-in-right" data-aos-duration="1200">
              <p className="section-label"><span></span> Sign Up</p>
              <h2 className="signup-title"> <span>Sign up as a</span> sporting complex</h2>
            </div>
            <div className="col-md-4" data-aos="zoom-in-left" data-aos-duration="1200">
              <p>Be the first to know when the app launches, and get early access to our referees, sporting directors and coaches.</p>
            </div>
          </div>

          <div className="form-wrapper" data-aos="zoom-in-down" data-aos-duration="1200">
            <form className="signup-form" onSubmit={handleSubmit}>
              <p className="form-instruction">Fill The Form Below:</p>

              <div className="row form-row">
                <div className="col-md-3">
                  <input
                    type="text"
                    name="firstName"
                    className="custom-input"
                    placeholder="First Name"
                    onChange={handleChange}
                  />
                  {errors.firstName && <small>{errors.firstName}</small>}
                </div>

                <div className="col-md-3">
                  <input
                    type="text"
                    name="lastName"
                    className="custom-input"
                    placeholder="Last Name"
                    onChange={handleChange}
                  />
                  {errors.lastName && <small>{errors.lastName}</small>}
                </div>

                <div className="col-md-3">
                  <input
                    type="email"
                    name="email"
                    className="custom-input"
                    placeholder="Email"
                    onChange={handleChange}
                  />
                  {errors.email && <small>{errors.email}</small>}
                </div>

                <div className="col-md-3">
                  <input
                    type="tel"
                    name="phone"
                    className="custom-input"
                    placeholder="Phone"
                    value={formData.phone || ""}
                    onChange={(e) => {
                      let value = e.target.value.replace(/\D/g, ""); // only numbers

                      // 🔥 limit length (max 15 digits)
                      if (value.length > 15) {
                        value = value.slice(0, 15);
                      }

                      setFormData((prev) => ({
                        ...prev,
                        phone: value,
                      }));
                    }}
                  />
                  {errors.phone && <small>{errors.phone}</small>}
                </div>

                <div className="col-md-3">
                  <input
                    type="text"
                    name="city"
                    className="custom-input"
                    placeholder="City"
                    onChange={handleChange}
                  />
                  {errors.city && <small>{errors.city}</small>}
                </div>

                <div className="col-md-3">
                  <input
                    type="text"
                    name="state"
                    className="custom-input"
                    placeholder="State"
                    onChange={handleChange}
                  />
                  {errors.state && <small>{errors.state}</small>}
                </div>

                <div className="col-md-3">
                  <input
                    type="text"
                    name="country"
                    className="custom-input"
                    placeholder="Country"
                    onChange={handleChange}
                  />
                  {errors.country && <small>{errors.country}</small>}
                </div>

                <div className="col-md-3">
                  <input
                    type="text"
                    name="location"
                    className="custom-input"
                    placeholder="Location"
                    onChange={handleChange}
                  />
                  {errors.location && <small>{errors.location}</small>}
                </div>
              </div>

              {/* FILES */}
              <div className="row form-upload-row">
                <div className="col-md-6">
                  <div className="upload-box">
                    <input
                      type="file"
                      name="certificate"
                      onChange={handleFileChange}
                    />

                    <i className="fa-solid fa-cloud-arrow-up"></i>
                    <p>Upload Business registration certificate</p>

                    {/* ✅ SHOW FILE NAME */}
                    {formData.certificate && (
                      <small className="file-name">
                        {formData.certificate.name}
                      </small>
                    )}

                    {errors.certificate && <small>{errors.certificate}</small>}
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="upload-box">
                    <input
                      type="file"
                      name="lease"
                      onChange={handleFileChange}
                    />

                    <i className="fa-solid fa-cloud-arrow-up"></i>
                    <p>Upload Lease Agreement</p>

                    {/* ✅ SHOW FILE NAME */}
                    {formData.lease && (
                      <small className="file-name">
                        {formData.lease.name}
                      </small>
                    )}

                    {errors.lease && <small>{errors.lease}</small>}
                  </div>
                </div>
              </div>

              <div className="form-actions">
                <button type="submit" className="btn-submit">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
